'use strict';

var _ = require('lodash');
var StepMarketSharePanelController = function StepMarketSharePanelController($scope, cellRendererService, HostShareService) {
  $scope.stepTitle = 'Market Share';
  $scope.stepEntered = function (event, stepTitle) {
    if (stepTitle === $scope.stepTitle) {
      $scope.pos = HostShareService.loadHostShare($scope.market, $scope.pos);
      $scope.gridOptions.rowData = $scope.pos.marketShare.data;
      $scope.gridOptions.api.onNewRows();
    }
  };
  var columnDefs = [{
    headerName: 'Day of Week',
    field: 'dayOfWeek'
  }, {
    headerName: 'Share',
    field: 'share',
    cellRenderer: _.wrap({
      model: 'pos.marketShare.data',
      min: 0,
      max: 100,
      tooltip: {
        container: '#step-market-share-tooltip',
        settings: 'msg-min="Share must be between 0 and 100" msg-max="Share must be between 0 and 100"'
      }
    }, cellRendererService.integerInputCellRenderer)
  }];
  $scope.gridOptions = _.defaults({
    columnDefs: columnDefs,
    rowData: $scope.pos.marketShare.data
  }, $scope.defaultGridOptions);
};
StepMarketSharePanelController.$inject = ['$scope', 'CellRendererService', 'HostShareService'];
module.exports = StepMarketSharePanelController;